export const UPDATE_BOARDSET_SUBTITLE_ACTION_TYPE =
  "UPDATE_BOARDSET_SUBTITLE_ACTION_TYPE" as const;

export const UPDATE_BOARDSET_NOTICE_ACTION_TYPE =
  "UPDATE_BOARDSET_NOTICE_ACTION_TYPE" as const;

export const UPDATE_BOARDSET_DELAY_ACTION_TYPE =
  "UPDATE_BOARDSET_DELAY_ACTION_TYPE" as const;
